import React from "react";
import "./skins.css";

function countItems(items) {
  return Array.isArray(items) ? items.length : 0;
}

function payloadTiles(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }
  return Object.entries(payload).slice(0, 4).map(([key, value], index) => ({
    label: key,
    value: String(value),
    tone: ["teal", "blue", "purple", "gray"][index] || "gray",
  }));
}

export default function StatusBoardSkin({ detail, item: itemProp, alerts: alertProp, controls: controlProp, latestPayload, latestReceivedAt }) {
  const item = itemProp || detail?.item || {};
  const alerts = alertProp || detail?.alerts || [];
  const controls = controlProp || item.control_profile || [];

  const tiles = [
    { label: "상태", value: item.status_label || item.status || "-", tone: "green" },
    ...payloadTiles(latestPayload),
    { label: "알림", value: `${countItems(alerts)}건`, tone: "red" },
    { label: "제어", value: `${countItems(controls)}개`, tone: "teal" },
    { label: "수신", value: latestReceivedAt ? "연결" : "없음", tone: latestReceivedAt ? "blue" : "gray" },
  ];

  return (
    <section className="status-board-skin">
      <header className="status-board-skin__header">
        <h3>{item.name || "상태 보드"}</h3>
      </header>
      <div className="status-board-skin__grid">
        {tiles.map((tile) => (
          <article className={`status-board-tile status-board-tile--${tile.tone}`} key={tile.label}>
            <span>{tile.label}</span>
            <strong>{tile.value}</strong>
          </article>
        ))}
      </div>
    </section>
  );
}
